module.exports = __webpack_public_path__ + "img/kr-product-card2-bottom-left.6fdbad2.png";